import { slideDown, slideUp } from '@/modules/functions';

export class Documents {
  documentsHidden;
  constructor() {}

  init() {
    this.documentsHidden = document.querySelectorAll('.documents-list.hidden');
    if (!this.documentsHidden || this.documentsHidden.length === 0) return;

    this.documentsHidden.forEach((el) => {
      const button = el.nextElementSibling;
      button.addEventListener('click', () => {
        if (button.classList.contains('showed')) {
          this.hideDocuments(el, button);
        } else {
          this.showDocuments(el, button);
        }
      });
    });
  }

  showDocuments(hiddenEl, button) {
    button.classList.add('showed');
    slideDown(hiddenEl, 500, 'flex');
  }

  hideDocuments(hiddenEl, button) {
    button.classList.remove('showed');
    slideUp(hiddenEl);
  }
}
